export default __webpack_public_path__ + "static/media/MJF.bc2f5ba0.jpg";